import { TTS } from './tts';
class SoundPlayer {
    constructor() {
        this.audio = null;
        this.playEndCallbacks = new Set();
        this.playStopCallbacks = new Set();
    }
    static getInstance() {
        if (!SoundPlayer.instance) {
            SoundPlayer.instance = new SoundPlayer();
        }
        return SoundPlayer.instance;
    }
    playSound(url, silent = false) {
        if (!silent)
            this.stopPlay();
        else
            this.stopPlaySilently();
        if (!this.audio) {
            this.audio = new Audio();
        }
        this.audio.src = url;
        this.audio.load();
        this.audio.oncanplay = () => {
            setTimeout(() => {
                this.audio?.play();
            }, 300);
        };
        this.audio.onended = () => {
            this.notifyPlayEnd();
        };
    }
    async playText(text) {
        this.stopPlay();
        await TTS.speak(text).then(() => {
            this.notifyPlayEnd();
        });
    }
    stopPlay() {
        if (this.audio) {
            this.audio.pause();
        }
        TTS.stop();
        this.notifyPlayStop();
    }
    stopPlaySilently() {
        if (this.audio) {
            this.audio.pause();
        }
        TTS.stop();
    }
    isPlaying() {
        const audioPlaying = this.audio && !this.audio.paused && !this.audio.ended;
        const ttsPlaying = TTS.isSpeaking();
        return audioPlaying || ttsPlaying;
    }
    onPlayEnd(callback) {
        this.playEndCallbacks.add(callback);
        // Return unsubscribe function
        return () => this.playEndCallbacks.delete(callback);
    }
    onPlayStop(callback) {
        this.playStopCallbacks.add(callback);
        // Return unsubscribe function
        return () => this.playStopCallbacks.delete(callback);
    }
    notifyPlayEnd() {
        this.playEndCallbacks.forEach(callback => callback());
    }
    notifyPlayStop() {
        this.playStopCallbacks.forEach(callback => callback());
    }
}
export default SoundPlayer.getInstance();
